import React from 'react';

const TermsAndConditionsPage = () => {
  return (
    <div className="policy-page container">
      <h1>Terms and Conditions</h1>
      <p><strong>Effective Date: 12/5/2025</strong></p>

      <h2>1. Introduction</h2>
      <p>Welcome to FB PROTECH WEB EXPERT ("we", "us", or "our"). By accessing or using our services, including website creation, advertising setup, SEO, and analytics integration, you agree to be bound by these Terms & Conditions.</p>

      <h2>2. Services</h2>
      <p>We provide digital services such as:</p>
      <ul>
        <li>Website design & development</li>
        <li>Facebook/Google ads setup and management</li>
        <li>Pixel and tracking setup</li>
        <li>SEO and digital consulting</li>
      </ul>
      <p>All services are subject to availability and agreement upon scope.</p>

      <h2>3. Payments</h2>
      <p>Full or partial payment may be required before work begins. Prices are listed in Malaysian Ringgit (RM) unless stated otherwise.</p>

      <h2>4. Client Responsibilities</h2>
      <p>Clients must provide required materials (e.g. logos, ad copy, credentials) on time. Delays in providing assets may result in project delays.</p>

      <h2>5. Revisions</h2>
      <p>We offer limited rounds of revisions per service package. Excess revisions may incur additional fees.</p>

      <h2>6. Limitation of Liability</h2>
      <p>We are not liable for any indirect, incidental, or consequential damages arising from service use, including ad performance outcomes or site downtime due to third-party tools.</p>

      <h2>7. Termination</h2>
      <p>We reserve the right to terminate service if a client violates these terms or engages in abusive behavior. Refunds are subject to our refund policy below.</p>

      <h2>8. Intellectual Property</h2>
      <p>All custom designs and content remain our intellectual property until full payment is received. After that, ownership is transferred to the client.</p>

      <h2>9. Governing Law</h2>
      <p>These terms are governed by the laws of Malaysia.</p>
    </div>
  );
};

export default TermsAndConditionsPage; 